import Vue from 'vue'
import { mapState } from 'vuex'
import { POSITION_TYPES, PositionType } from '@/constants/vacancies/positionTypes'
import { SalaryTypes } from '@/constants/vacancies/SalaryTypes'
import VacancyLocationTooltip from '@/partials/VacancyLocationTooltip/VacancyLocationTooltip.vue'
import { RootState } from '@/store'
import { formatUsd } from '@/utils/moneyFormat'

export default Vue.extend<any, any, any, any>({
  components: {
    VacancyLocationTooltip,
  },
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
    }),
    vacancy() {
      return this.application.vacancy
    },
    isRangeSalary() {
      return this.vacancy.salary_type === SalaryTypes.RANGE
    },
    positionType() {
      return POSITION_TYPES[this.vacancy.positionType as PositionType]?.name
    },
    remoteInfo() {
      return this.application.remoteInfo
    },
  },
  methods: {
    formatUsd,
  },
})
